import { Component, Input, OnChanges, OnDestroy, SimpleChange } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ValidationMessageService } from '../../../services/validation-message.service';

@Component({
    selector: 'app-field-error-display',
    templateUrl: './field-error-display.component.html',
    styleUrls: ['./field-error-display.component.scss'],
})
export class FieldErrorDisplayComponent implements OnChanges, OnDestroy
{

    @Input() control: AbstractControl;
    @Input() errorsWhenPristine = false;
    @Input() useConsolidatedMessage = false;

    errorMessage: string = null;

    private _validationMessageService: ValidationMessageService;

    constructor(_validationMessageService: ValidationMessageService) {
        this._validationMessageService = _validationMessageService;
    }

    ngOnDestroy() {
    }

    ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
        const messages: any[] = [];
        if (this.control && this.control.errors) {
            if (this.useConsolidatedMessage) {
                // Use for fields that have multiple errors to correct (password-hinter)
                messages.push('Please correct errors for this field.');
            } else {
                for (const p in this.control.errors) {
                    // For each error.
                    if (this.control.errors.hasOwnProperty(p) && (this.errorsWhenPristine || this.control.touched || !this.control.pristine)) {
                        // Get the appropriate error message.
                        const msg: any = this._validationMessageService.getGenericErrorMessage(p, this.control.errors[p]);
                        if (!msg) {
                            if (this.control.errors[p] !== true) {
                                messages.push(this.control.errors[p]);
                            }
                        } else {
                            messages.push(msg);
                        }
                    }
                }
            }
        }

        if (messages.length > 0) {
            this.errorMessage = messages.join('<br />');
        } else {
            this.errorMessage = null;
        }
    }


}
